import React, { useEffect } from "react";
import styled, { css } from "styled-components";
import DashboardCallAgain from "./DashboardCallAgain";
import RoadMap from "./roadmap/RoadMap";
import DashboardByUser from "./DashboardByUser";
import { useDispatch, useSelector } from "react-redux";
import { loadProjects } from "../project/projects/projectsAction";
import PitchStrategy from "../strategy/pitch_strategy/PitchStrategy";
import { Link, Outlet, useLocation } from "react-router-dom";
import EnjoyBoard from "./EnjoyBoard";
import {
  CALL_AGAIN_BOARD_ROUTES,
  ENJOY_BOARD_ROUTE,
  MEMBERS_BOARD_ROUTES,
  PITCH_STRATEGY_ROUTE,
  ROADMAP_ROUTES,
} from "../../routes/routesName";

const DashBoards = () => {
  const pitch = "pitch";
  const callAgainBoard = "callAgainBoard";
  const roadmap = "roadmap";
  const enjoy360 = "enjoy360";
  const enjoyBoard = "enjoyBoard";
  const location = useLocation();

  const dispatch = useDispatch();
  const { status: currentUserStatus, id: currentUserId } = useSelector(
    (state) => state.currentUser
  );

  useEffect(() => {
    // waiting that the current user is fetched to load projects (asynchronous to handle refresh token)
    if (currentUserStatus === 200) {
      dispatch(loadProjects(currentUserId));
    }
  }, [currentUserId, currentUserStatus, dispatch]);

  const displayComponents = () => {
    if (location.pathname === PITCH_STRATEGY_ROUTE) {
      return <PitchStrategy />;
    }
    if (location.pathname === CALL_AGAIN_BOARD_ROUTES) {
      return <DashboardCallAgain />;
    }
    if (location.pathname === ROADMAP_ROUTES) {
      return <RoadMap />;
    }
    if (location.pathname === MEMBERS_BOARD_ROUTES) {
      return <DashboardByUser />;
    }
   /**
    *  if (location.pathname === ENJOY_BOARD_ROUTE) {
    *       return <EnjoyBoard />;
    *     }
    * */
  };

  const buttons = [
    { id: pitch, name: "Pitch Stratégie", link: PITCH_STRATEGY_ROUTE },
    {
      id: callAgainBoard,
      name: "Tableau de relance",
      link: CALL_AGAIN_BOARD_ROUTES,
    },
    { id: roadmap, name: "Roadmap", link: ROADMAP_ROUTES },
    {
      id: enjoy360,
      name: "Enjoy 360° collaborateurs",
      link: MEMBERS_BOARD_ROUTES,
    },
    /**
     * { id: enjoyBoard, name: "Enjoy Board", link: ENJOY_BOARD_ROUTE },
     * */
  ];

  return (
    <Container>
      <Outlet />
      <ContainerLink>
        {buttons.map((b) => (
          <StyledLink
            key={b.link}
            to={b.link}
            $mode={location.pathname.includes(b.link)}
          >
            <LinkTitle $mode={location.pathname.includes(b.link)}>
              {b.name}
            </LinkTitle>
          </StyledLink>
        ))}
      </ContainerLink>
      <ContainerComponent>{displayComponents()}</ContainerComponent>
    </Container>
  );
};

const LinkTitle = styled.p`
  color: var(--color-white);
  ${(props) => {
    switch (props.$mode) {
      case true:
        return css`
          color: var(--color-purple);
        `;
      default:
        return css``;
    }
  }}
`;

const StyledLink = styled(Link)`
  border: 2px solid transparent;
  border-radius: 15px;
  padding: 0.5rem 2rem;
  background: var(--color-purple);
  cursor: pointer;
  color: var(--color-white);
  font-weight: 600;
  ${(props) => {
    switch (props.$mode) {
      case true:
        return css`
          border-color: var(--color-purple);
          background: transparent;

          color: var(--color-purple);
        `;
      default:
        return css``;
    }
  }}

  &:hover {
    border-color: var(--color-purple);
    background: transparent;

    p {
      color: var(--color-purple);
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 3rem;
  width: 100%;
`;
const ContainerLink = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  @media print {
    display: none;
  }
`;
const ContainerComponent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
export default DashBoards;
